import { render, staticRenderFns } from "./Switchboard.vue?vue&type=template&id=3122c16a&scoped=true&"
import script from "./Switchboard.vue?vue&type=script&lang=js&"
export * from "./Switchboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3122c16a",
  null
  
)

export default component.exports